import React from 'react';

const ShippouEffect = () => {
  // 七宝柄のパターン生成
  const generateShippouPattern = () => {
    const rowLength = Math.ceil(window.innerWidth / 80);
    const colLength = Math.ceil(window.innerHeight / 40);
    
    const rows = [];
    for (let i = 0; i < colLength; i++) {
      const row = [];
      for (let j = 0; j < rowLength; j++) {
        if (i % 2 === 0) {
          row.push({ id: `${i}-${j}-left`, type: 'left' });
          row.push({ id: `${i}-${j}-right`, type: 'right' });
        } else {
          row.push({ id: `${i}-${j}-right`, type: 'right' });
          row.push({ id: `${i}-${j}-left`, type: 'left' });
        }
      }
      rows.push(row);
    }
    return rows;
  };

  const shippouRows = generateShippouPattern();

  const styles = {
    effectContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      overflow: 'hidden',
    },
    blueBgLeft: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '50%',
      height: '100%',
      background: 'linear-gradient(to left, #2563eb 0%, #3b82f6 100%)',
      zIndex: 10,
      animation: 'slideOutLeft 2s ease-in-out 3s forwards',
    },
    blueBgRight: {
      position: 'absolute',
      top: 0,
      right: 0,
      width: '50%',
      height: '100%',
      background: 'linear-gradient(to right, #2563eb 0%, #3b82f6 100%)',
      zIndex: 10,
      animation: 'slideOutRight 2s ease-in-out 3s forwards',
    },
    stripeContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      zIndex: 5,
    },
    stripe1: {
      flex: 1,
      background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)',
      animation: 'slideInFromTop 2s ease-out 5s forwards',
      transform: 'translateY(-100%)',
    },
    stripe2: {
      flex: 1,
      background: '#3b82f6',
      animation: 'slideInFromBottom 2s ease-out 5s forwards',
      transform: 'translateY(100%)',
    },
    stripe3: {
      flex: 1,
      background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)',
      animation: 'slideInFromTop 2s ease-out 5s forwards',
      transform: 'translateY(-100%)',
    },
    stripe4: {
      flex: 1,
      background: '#3b82f6',
      animation: 'slideInFromBottom 2s ease-out 5s forwards',
      transform: 'translateY(100%)',
    },
    stripe5: {
      flex: 1,
      background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)',
      animation: 'slideInFromTop 2s ease-out 5s forwards',
      transform: 'translateY(-100%)',
    },
    wipeYellow: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: '#fbbf24',
      zIndex: 15,
      clipPath: 'circle(0% at 100% 100%)',
      animation: 'wipeFromBottomRight 2s ease-in-out 9s forwards',
    },
    wipeNavy: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: '#1e3a8a',
      zIndex: 20,
      clipPath: 'circle(0% at 0% 100%)',
      animation: 'wipeFromBottomLeft 2s ease-in-out 14s forwards',
    },
    shippouContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      zIndex: 21,
      clipPath: 'circle(0% at 0% 100%)',
      animation: 'wipeFromBottomLeft 2s ease-in-out 14s forwards',
      display: 'flex',
      flexDirection: 'column',
    },
    shippouRow: {
      display: 'flex',
    },
    leftLeaf: {
      width: '40px',
      height: '40px',
      backgroundColor: 'rgba(255, 255, 255, 0.02)',
      borderRadius: '100% 0',
    },
    rightLeaf: {
      width: '40px',
      height: '40px',
      backgroundColor: 'rgba(255, 255, 255, 0.02)',
      borderRadius: '0 100%',
    },
  };

  return (
    <div style={styles.effectContainer}>
      <style>
        {`
          @keyframes slideOutLeft {
            to {
              transform: translateX(-100%);
            }
          }

          @keyframes slideOutRight {
            to {
              transform: translateX(100%);
            }
          }

          @keyframes slideInFromTop {
            to {
              transform: translateY(0);
            }
          }

          @keyframes slideInFromBottom {
            to {
              transform: translateY(0);
            }
          }

          @keyframes wipeFromBottomRight {
            to {
              clip-path: circle(150% at 100% 100%);
            }
          }

          @keyframes wipeFromBottomLeft {
            to {
              clip-path: circle(150% at 0% 100%);
            }
          }
        `}
      </style>

      {/* 青い背景A（左右に分割） */}
      <div style={styles.blueBgLeft}></div>
      <div style={styles.blueBgRight}></div>

      {/* 縦5等分の帯 */}
      <div style={styles.stripeContainer}>
        <div style={styles.stripe1}></div>
        <div style={styles.stripe2}></div>
        <div style={styles.stripe3}></div>
        <div style={styles.stripe4}></div>
        <div style={styles.stripe5}></div>
      </div>

      {/* 黄色ワイプ（右下起点） */}
      <div style={styles.wipeYellow}></div>

      {/* 紺色ワイプ（左下起点） */}
      <div style={styles.wipeNavy}></div>

      {/* 七宝柄パターン */}
      <div style={styles.shippouContainer}>
        {shippouRows.map((row, i) => (
          <div key={i} style={styles.shippouRow}>
            {row.map((leaf) => (
              <div
                key={leaf.id}
                style={leaf.type === 'left' ? styles.leftLeaf : styles.rightLeaf}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShippouEffect;